export const PUBLIC_SITE_ORIGIN = 'https://www.iqlabtest.com';

export function publicSiteUrl(path = '/'): string {
  const prefixedPath = path.startsWith('/') ? path : `/${path}`;
  const canonicalPath = prefixedPath === '/' ? '/' : `${prefixedPath.replace(/\/+$/, '')}/`;
  return `${PUBLIC_SITE_ORIGIN}${canonicalPath}`;
}
